/**
 * Comparador de Produtos - Le Fruit
 * Script para controlar o fluxo da página de comparação de produtos
 */

document.addEventListener('DOMContentLoaded', function() {
  // Elementos da interface
  const progressSteps = document.querySelectorAll('.progress-step');
  const progressLines = document.querySelectorAll('.progress-line');
  const compareSteps = document.querySelectorAll('.compare-step');
  const prevButton = document.querySelector('.prev-step');
  const nextButton = document.querySelector('.next-step');
  
  // Estado da aplicação
  const state = {
    currentStep: 1,
    selectedCollection: null,
    selectedProducts: [],
    productsData: {}
  };
  
  // Carregar estado salvo, se existir
  const savedState = localStorage.getItem('productCompareState');
  if (savedState) {
    try {
      const parsed = JSON.parse(savedState);
      if (parsed.currentStep) {
        state.currentStep = parsed.currentStep;
        state.selectedCollection = parsed.selectedCollection;
        state.selectedProducts = parsed.selectedProducts;
        state.productsData = parsed.productsData;
        
        // Atualizar a interface baseado no estado salvo
        goToStep(state.currentStep);
        
        if (state.selectedCollection) {
          updateProductSelector(state.selectedCollection);
        }
        
        if (state.selectedProducts.length > 0 && state.productsData) {
          updateComparisonView();
        }
      }
    } catch (e) {
      console.error('Erro ao carregar estado salvo:', e);
      localStorage.removeItem('productCompareState');
    }
  }
  
  // Inicialização
  init();
  
  /**
   * Inicializa a aplicação
   */
  function init() {
    // Configurar eventos da etapa 1 - Seleção de coleção
    setupCollectionSelection();
    
    // Configurar botões de navegação
    setupNavigation();
    
    // Atualizar botões baseado na etapa atual
    updateNavigationButtons();
  }
  
  /**
   * Configura os eventos da seleção de coleção
   */
  function setupCollectionSelection() {
    const collectionItems = document.querySelectorAll('.collection-item');
    
    collectionItems.forEach(item => {
      item.addEventListener('click', function() {
        // Remover seleção anterior
        collectionItems.forEach(i => i.classList.remove('selected'));
        
        // Selecionar o item atual
        this.classList.add('selected');
        
        // Salvar a coleção selecionada
        const collectionId = this.getAttribute('data-collection-id');
        const collectionHandle = this.getAttribute('data-collection-handle');
        const collectionTitle = this.querySelector('.collection-title').textContent;
        
        state.selectedCollection = {
          id: collectionId,
          handle: collectionHandle,
          title: collectionTitle
        };
        
        // Ativar o botão de continuar
        nextButton.disabled = false;
        
        // Salvar o estado
        saveState();
      });
    });
  }
  
  /**
   * Configura os eventos de navegação entre etapas
   */
  function setupNavigation() {
    prevButton.addEventListener('click', function() {
      if (state.currentStep > 1) {
        goToStep(state.currentStep - 1);
      }
    });
    
    nextButton.addEventListener('click', function() {
      if (state.currentStep === 3) {
        // Reiniciar o comparador
        resetComparison();
        goToStep(1);
      } else if (state.currentStep < 3) {
        // Validar antes de avançar
        if (validateCurrentStep()) {
          goToStep(state.currentStep + 1);
        }
      }
    });
    
    // Função para reiniciar o comparador
    function resetComparison() {
      // Limpar o estado
      state.selectedCollection = null;
      state.selectedProducts = [];
      state.productsData = {};
      
      // Limpar a interface
      const selectedItems = document.querySelectorAll('.collection-item.selected, .product-item.selected');
      selectedItems.forEach(item => item.classList.remove('selected'));
      
      // Limpar o localStorage
      localStorage.removeItem('productCompareState');
    }
    
    // Botões adicionais para navegar entre etapas
    const backToCollectionsBtn = document.querySelector('.back-to-collections');
    if (backToCollectionsBtn) {
      backToCollectionsBtn.addEventListener('click', function() {
        goToStep(1);
      });
    }
    
    const selectDifferentProductsBtn = document.querySelector('.select-different-products');
    if (selectDifferentProductsBtn) {
      selectDifferentProductsBtn.addEventListener('click', function() {
        goToStep(2);
      });
    }
    
    const selectDifferentCollectionBtn = document.querySelector('.select-different-collection');
    if (selectDifferentCollectionBtn) {
      selectDifferentCollectionBtn.addEventListener('click', function() {
        goToStep(1);
      });
    }
  }
  
  /**
   * Navega para uma etapa específica
   */
  function goToStep(step) {
    // Validar se é possível ir para a etapa
    if (step > 1 && !validatePreviousSteps(step)) {
      return;
    }
    
    // Atualizar estado
    state.currentStep = step;
    
    // Atualizar indicador de progresso
    progressSteps.forEach((s, i) => {
      s.classList.remove('active', 'completed');
      if (i + 1 === step) {
        s.classList.add('active');
      } else if (i + 1 < step) {
        s.classList.add('completed');
      }
    });
    
    // Atualizar linhas de progresso
    progressLines.forEach((line, i) => {
      line.classList.remove('active');
      if (i + 1 < step) {
        line.classList.add('active');
      }
    });
    
    // Mostrar a etapa correta
    compareSteps.forEach((s, i) => {
      s.classList.remove('active');
      if (i + 1 === step) {
        s.classList.add('active');
      }
    });
    
    // Executar ações específicas da etapa
    if (step === 2 && state.selectedCollection) {
      updateProductSelector(state.selectedCollection);
    } else if (step === 3 && state.selectedProducts.length === 2) {
      updateComparisonView();
    }
    
    // Atualizar botões de navegação
    updateNavigationButtons();
    
    // Salvar o estado
    saveState();
    
    // Atualizar a URL com a etapa atual (sem recarregar a página)
    const url = new URL(window.location.href);
    url.searchParams.set('step', step);
    window.history.replaceState({}, '', url);
  }
  
  /**
   * Valida se é possível avançar da etapa atual
   */
  function validateCurrentStep() {
    switch (state.currentStep) {
      case 1:
        return state.selectedCollection !== null;
      case 2:
        return state.selectedProducts.length === 2;
      default:
        return true;
    }
  }
  
  /**
   * Valida se todas as etapas anteriores foram concluídas
   */
  function validatePreviousSteps(targetStep) {
    if (targetStep === 2) {
      return state.selectedCollection !== null;
    } else if (targetStep === 3) {
      return state.selectedCollection !== null && state.selectedProducts.length === 2;
    }
    return true;
  }
  
  /**
   * Atualiza os botões de navegação baseado na etapa atual
   */
  function updateNavigationButtons() {
    // Botão anterior
    prevButton.disabled = state.currentStep === 1;
    
    // Botão próximo
    if (state.currentStep === 3) {
      nextButton.textContent = 'Reiniciar';
      nextButton.classList.add('restart-button');
      nextButton.disabled = false;
    } else {
      nextButton.textContent = 'Continue';
      nextButton.classList.remove('restart-button');
      nextButton.disabled = !validateCurrentStep();
    }
  }
  
  /**
   * Atualiza a seção de seleção de produtos baseado na coleção selecionada
   */
  function updateProductSelector(collection) {
    const productSelector = document.querySelector('.product-selector');
    const productGrid = productSelector.querySelector('.product-grid');
    const noProductsMessage = productSelector.querySelector('.no-products-message');
    const collectionTitleDisplay = productSelector.querySelector('.collection-title-display');
    const selectedCountElement = productSelector.querySelector('.selected-count');
    
    // Atualizar o título
    collectionTitleDisplay.textContent = ` da coleção ${collection.title}`;
    
    // Mostrar loader
    productGrid.innerHTML = `
      <div class="loading-spinner">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 6v6l4 2"></path>
        </svg>
        <span>Carregando produtos...</span>
      </div>
    `;
    
    // Atualizar atributo data-collection-handle
    productSelector.setAttribute('data-collection-handle', collection.handle);
    
    // Carregar produtos da coleção via fetch
    fetch(`/collections/${collection.handle}/products.json`)
      .then(response => response.json())
      .then(data => {
        const products = data.products;
        
        // Verificar se há produtos suficientes
        if (products.length < 2) {
          productGrid.innerHTML = '';
          noProductsMessage.style.display = 'block';
          return;
        }
        
        noProductsMessage.style.display = 'none';
        
        // Limpar o grid
        productGrid.innerHTML = '';
        
        // Adicionar os produtos
        products.forEach(product => {
          const isSelected = state.selectedProducts.some(p => p.id === product.id);
          
          // Salvar dados do produto para uso posterior
          state.productsData[product.id] = product;
          
          // Criar elemento do produto
          const productElement = document.createElement('div');
          productElement.className = `product-item${isSelected ? ' selected' : ''}`;
          productElement.setAttribute('data-product-id', product.id);
          
          // Determinar preço e imagem
          const featuredImage = product.images.length > 0 ? product.images[0].src : '';
          const imageUrl = featuredImage ? featuredImage.replace(/(\.[^.]*)$/, '_300x$1') : '';
          
          const variant = product.variants[0];
          const price = formatMoney(variant.price);
          const comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
          
          productElement.innerHTML = `
            <div class="product-item-inner">
              <div class="product-image">
                ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
              </div>
              <h3 class="product-title">${product.title}</h3>
              <div class="product-price">
                ${comparePrice ? `<span class="product-compare-price">${comparePrice}</span>` : ''}
                ${price}
              </div>
            </div>
          `;
          
          // Adicionar evento de clique
          productElement.addEventListener('click', function() {
            const productId = this.getAttribute('data-product-id');
            
            // Verificar se já está selecionado
            const alreadySelected = state.selectedProducts.some(p => p.id === productId);
            
            if (alreadySelected) {
              // Remover da seleção
              state.selectedProducts = state.selectedProducts.filter(p => p.id !== productId);
              this.classList.remove('selected');
            } else {
              // Se já tem 2 produtos selecionados, remover o primeiro
              if (state.selectedProducts.length >= 2) {
                const firstProductId = state.selectedProducts[0].id;
                state.selectedProducts.shift();
                
                const firstProductElement = document.querySelector(`.product-item[data-product-id="${firstProductId}"]`);
                if (firstProductElement) {
                  firstProductElement.classList.remove('selected');
                }
              }
              
              // Adicionar à seleção
              state.selectedProducts.push({
                id: productId,
                title: product.title
              });
              this.classList.add('selected');
            }
            
            // Atualizar contador
            selectedCountElement.textContent = state.selectedProducts.length;
            
            // Atualizar botão de próximo
            nextButton.disabled = state.selectedProducts.length !== 2;
            
            // Salvar o estado
            saveState();
          });
          
          // Adicionar ao grid
          productGrid.appendChild(productElement);
        });
        
        // Atualizar contador
        selectedCountElement.textContent = state.selectedProducts.length;
      })
      .catch(error => {
        console.error('Erro ao carregar produtos:', error);
        productGrid.innerHTML = `
          <div class="error-message">
            <p>Ocorreu um erro ao carregar os produtos. Por favor, tente novamente.</p>
          </div>
        `;
      });
  }
  
  /**
   * Atualiza a visualização de comparação
   */
  function updateComparisonView() {
    if (state.selectedProducts.length !== 2) return;
    
    const product1 = state.productsData[state.selectedProducts[0].id];
    const product2 = state.productsData[state.selectedProducts[1].id];
    
    if (!product1 || !product2) return;
    
    // Elementos de produto 1
    const product1Image = document.querySelector('.product-1-image');
    const product1Title = document.querySelector('.product-1-title');
    const product1Price = document.querySelector('.product-1-price');
    const product1Link = document.querySelector('.product-1-link');
    const product1Description = document.querySelector('.product-1-description');
    const product1Availability = document.querySelector('.product-1-availability');
    const product1Sku = document.querySelector('.product-1-sku');
    const product1Variants = document.querySelector('.product-1-variants');
    
    // Elementos de produto 2
    const product2Image = document.querySelector('.product-2-image');
    const product2Title = document.querySelector('.product-2-title');
    const product2Price = document.querySelector('.product-2-price');
    const product2Link = document.querySelector('.product-2-link');
    const product2Description = document.querySelector('.product-2-description');
    const product2Availability = document.querySelector('.product-2-availability');
    const product2Sku = document.querySelector('.product-2-sku');
    const product2Variants = document.querySelector('.product-2-variants');
    
    // Atualizar produto 1
    updateProductDisplay(
      product1,
      product1Image,
      product1Title,
      product1Price,
      product1Link,
      product1Description,
      product1Availability,
      product1Sku,
      product1Variants
    );
    
    // Atualizar produto 2
    updateProductDisplay(
      product2,
      product2Image,
      product2Title,
      product2Price,
      product2Link,
      product2Description,
      product2Availability,
      product2Sku,
      product2Variants
    );
  }
  
  /**
   * Atualiza a exibição de um produto na visualização de comparação
   */
  function updateProductDisplay(
    product,
    imageElement,
    titleElement,
    priceElement,
    linkElement,
    descriptionElement,
    availabilityElement,
    skuElement,
    variantsElement
  ) {
    if (!product) return;
    
    // Imagem do produto
    const featuredImage = product.images.length > 0 ? product.images[0].src : '';
    const imageUrl = featuredImage ? featuredImage.replace(/(\.[^.]*)$/, '_300x$1') : '';
    
    imageElement.innerHTML = imageUrl 
      ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">`
      : '';
    
    // Título e link
    titleElement.textContent = product.title;
    linkElement.href = `/products/${product.handle}`;
    
    // Preço
    const variant = product.variants[0];
    const price = formatMoney(variant.price);
    const comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
    
    priceElement.innerHTML = comparePrice 
      ? `<span class="product-compare-price">${comparePrice}</span> ${price}`
      : price;
    
    // Descrição
    descriptionElement.innerHTML = product.body_html || 'Sem descrição disponível';
    
    // Disponibilidade
    const isAvailable = product.variants.some(v => v.available);
    availabilityElement.innerHTML = isAvailable 
      ? '<span class="available"><i class="fa fa-check-circle"></i> Em estoque</span>'
      : '<span class="unavailable"><i class="fa fa-times-circle"></i> Fora de estoque</span>';
    
    // SKU
    skuElement.textContent = variant.sku || 'N/A';
    
    // Variantes
    if (product.options.length > 0) {
      let variantsHtml = '';
      
      product.options.forEach(option => {
        variantsHtml += `<div class="product-option">
          <strong>${option.name}:</strong> 
          ${option.values.join(', ')}
        </div>`;
      });
      
      variantsElement.innerHTML = variantsHtml;
    } else {
      variantsElement.textContent = 'Sem opções disponíveis';
    }
  }
  
/**
 * Formata um valor em centavos para exibição como moeda
 */
function formatMoney(cents) {
  // Convertemos o valor de centavos para reais
  const valueInReais = cents / 100;

  // Usamos a API Intl.NumberFormat para formatar como moeda brasileira
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valueInReais);
}
  
  /**
   * Salva o estado atual no localStorage
   */
  function saveState() {
    localStorage.setItem('productCompareState', JSON.stringify(state));
  }
});
